import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// Create invites for one or more email addresses
export const createInvites = async (inviteData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/invites`, inviteData);
    return response.data;
  } catch (error) {
    console.error('Error creating invites:', error.response?.data || error);
    throw error;
  }
};

export const checkInviteEmailAccount = async (email) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/invites/email-check`, {
      params: { email },
    });
    return response.data;
  } catch (error) {
    console.error('Error checking invite email account:', error.response?.data || error);
    throw error;
  }
};

// Redeem an invite token
export const redeemInvite = async (redeemData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/invites/redeem`, redeemData);
    return response.data;
  } catch (error) {
    console.error('Error redeeming invite:', error.response?.data || error);
    throw error;
  }
};

// Resend an invite by issuing a new token
export const resendInvite = async (resendData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/invites/resend`, resendData);
    return response.data;
  } catch (error) {
    console.error('Error resending invite:', error.response?.data || error);
    throw error;
  }
};

// Revoke an invite
export const revokeInvite = async (revokeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/invites/revoke`, revokeData);
    return response.data;
  } catch (error) {
    console.error('Error revoking invite:', error.response?.data || error);
    throw error;
  }
};

// List pending invites for a tenant
export const listPendingInvites = async (tenantId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/invites/pending`, {
      params: { tenantId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching pending invites:', error.response?.data || error);
    throw error;
  }
};
